<template>
  <b-modal
    v-model="showModal"
    title="Add Bioreq Document"
    centered
    ok-title="Confirm"
    cancel-title="Cancel"
    @show="handleShow"
    @ok="handleOk"
  >
    <form-wrapper>
      <b-form @submit.stop.prevent="onSubmit">
        <b-form-group>
          <label for="title-input">Title</label>
          <b-form-input
            v-validate="'required'"
            id="title-input"
            :disabled="saving"
            :value="fields.title"
            class="form-control"
            type="text"
            name="title"
            @input="setTitle"
          />
        </b-form-group>

        <b-form-group>
          <label for="description-input">Description</label>
          <b-form-textarea
            v-validate="'required'"
            id="description-input"
            :disabled="saving"
            :rows="3"
            :max-rows="6"
            :value="fields.description"
            type="text"
            name="description"
            @input="setDescription"/>
        </b-form-group>

        <b-form-group>
          <input
            id="file-input"
            :disabled="saving"
            :class="{ 'is-invalid' : errors.has('file') || apiErrors.file.length }"
            type="file"
            accept="apiConfig.bioreq_types"
            name="file"
            @change="setFile"/>
        </b-form-group>
                
        <form-success :success="success" class="form-alert">Bioreq document uploaded!</form-success>
      </b-form>
    </form-wrapper>
  </b-modal>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import formSuccess from '../../../common/form/form-success'
import formWrapper from '../../../common/form/form-wrapper'
import validationErrors from '../../../common/form/validation-errors'

export default {
  components: {
    formSuccess,
    formWrapper,
    validationErrors
  },
  data() {
    return {
      showModal: false
    }
  },
  computed: {  
    ...mapState('bioreq/forms/store', [
      'apiErrors',
      'fields',
      'success',
      'saving'
    ]),
    ...mapState('config', {
      apiConfig: 'data'
    }),
    disabled () {
      return this.errors.any() || this.saving
    }
  },
  watch: {
    showModal: function (newState, oldState) {
      if (newState === false) {
        this.$emit('hidden')
      }
    },
    success (newValue, oldValue) {
      if (newValue === true && oldValue === false) {
        this.errors.clear()
        this.$store.commit('bioreq/forms/store/resetFields')
        this.showModal = false
      }
    }
  },
  methods: {
    ...mapActions({
      storeBioreq: 'bioreq/store'
    }),
    openModal () {
      this.showModal = true
    },
    onSubmit () {
      this.$validator.validateAll().then((validateResult) => {
        if (validateResult) {
          this.storeBioreq().then((storeResult) => {
            this.showModal = false
          })
        }
      })
    },
    setTitle (event) {
      this.$store.commit('bioreq/forms/store/setField', {
        field: 'title',
        value: event
      })
    },
    setDescription (event) {
      this.$store.commit('bioreq/forms/store/setField', {
        field: 'description',
        value: event
      })
    },
    setFile (event) {
      let file
      if (event.target && event.target.files) {
        file = event.target.files[0]
      } else {
        file = event
      }

      this.$store.commit('bioreq/forms/store/setField', {
        field: 'file',
        value: file
      })
    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      // Trigger submit handler
      this.onSubmit()
    },
    handleShow () {
      this.$store.commit('bioreq/forms/store/resetFields')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/client/bioreq/addModal.vue